
import { Vue } from 'vue-class-component';
import motoboy from "@/services/motoboy";

export default class HomeView extends Vue {
  motoboys: IMotoboy[] = [];
  filtroNomeMotoboy: string = "";
  isLoading: boolean = false;
  errorMessage: string | null = null;
  debounceTimer: number | null = null;

  mounted(): void {
    this.carregarMotoboys();
    motoboy.saveSignOffline();
    motoboy.saveFailOffline();
  }

  async carregarMotoboys(): Promise<void> {
    this.isLoading = true;
    this.errorMessage = null;
    try {
      const res = await motoboy.listBoys(navigator.onLine);
      if (Array.isArray(res)) {
        this.motoboys = res;
      } else {
        this.errorMessage = 'Erro ao carregar motoboys. Tente novamente.';
      }
    } catch (e: any) {
      console.error(e);
      this.errorMessage = 'Erro ao carregar motoboys: ' + (e.message || 'Tente novamente.');
    } finally {
      this.isLoading = false;
    }
  }

  selecionarMotoboy(motoboy: IMotoboy): void {
    this.$router.push({ name: 'Entregas', params: { id: motoboy.id_fun.toString() } });
  }

  get motoboysFiltrados(): IMotoboy[] {
    if (!this.filtroNomeMotoboy) {
      return this.motoboys;
    }
    const filtroLower = this.filtroNomeMotoboy.toLowerCase();
    return this.motoboys.filter(m =>
        m.nome_fun?.toLowerCase().includes(filtroLower)
    );
  }

  updated() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
    }, 300);
  }
}
